var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shipment-item-proposals-item-expiration",class:{
    expiring: _vm.isExpiring
  }},[_c('div',{staticClass:"tw-flex"},[_c('ui-ctk-icon',{attrs:{"name":"expiration"}}),_c('span',{staticClass:"fs-13"},[_vm._v(" "+_vm._s(_vm.$t('app.labels.proposals.expires_in', { time: _vm.$moment(_vm.proposal.expires_at).fromNow(true) }))+" ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }